<template>
  <div>
    <LmListV2
      ref='LmDataTableListbuilder'
      isGraphql
      :gqlField='gqlField'
      :gqlVariables='gqlVariables'
      :gqlQuery='gqlQuery'
      :searchOnFieldsSelected='searchOnFieldsSelected'
      :searchOnFieldsToSelected='searchOnFieldsToSelected'
      :items='items'
      :mode='mode'
      :allAvailableFields='fields'
      :listBuilderTitleList='listBuilderTitleList'
    />
  </div>
</template>

<script>
import LmListV2 from '@/components/LmListV2.vue'

export default {
  components: {
    LmListV2
  },
  data () {
    return {
      listBuilderTitleList: 'Listado de Tablas de datos',
      gqlField: 'datatables',
      gqlVariables: {
        q: '*',
        sort: 'updatedAt__desc',
        page: 1
      },
      gqlQuery: `query($page:Int, $q:String, $sort:[DatatablesESSortEnum]) {
      datatables(
          titleList: "Tablas de datos"
          aggs: []
          q: $q
          perPage: 10
          page: $page
          sort: $sort
          metaSearch: "*"
          opts: {
            lenient: true
          }
          lmPathActions: [{to:"/datatable/editar/:slug",tooltip:"Editar",fontAwesomeIcon:"edit"}, {to:"/listado/:slug",tooltip:"Ver",fontAwesomeIcon:"eye"}]
          lmModalActions: []
          buttonLinks: [{value:"Nuevo",to:"/datatable/nuevo",endpointToValidateVisibility:"",show:true,disabled:false,buttonClass:"btn-info",buttonColor:"#17a2b8",enableOnSelectedRows:false,type:"redirect",requestEndpoint:"",requestConfirmation:false}]
          ) {
          count
          searcher
          tableItemsTotal
          titleList
          filter {
            aggregatesToSelect
          }
          itemsPerPage
          table {
            items {
              name,alias,deleted,createdBy,updatedBy,actions
            }
            fields {
              key
              label
              sortable
            }
          }
          buttons
          pagination
        }
      }`,
      searchOnFieldsSelected: [
        'slug',
        'createdAt',
        'updatedAt',
        'actions',
        'createdBy',
        'updatedBy',
        'meta',
        'name',
        'alias',
        'deleted'
      ],
      searchOnFieldsToSelected: [
        'slug',
        'createdAt',
        'updatedAt',
        'actions',
        'createdBy',
        'updatedBy',
        'meta',
        'name',
        'alias',
        'deleted'
      ],
      items: [
        {
          name: 'name'
        },
        {
          name: 'alias'
        },
        {
          name: 'deleted'
        },
        {
          name: 'createdBy'
        },
        {
          name: 'updatedBy'
        },
        {
          name: 'actions'
        }
      ],
      mode: {
        table: true,
        map: false,
        box: false
      },
      fields: [
        {
          key: 'name',
          label: 'Nombre',
          sortable: true
        },
        {
          key: 'alias',
          label: 'Alias',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'Eliminado',
          sortable: false
        },
        {
          key: 'updatedBy',
          label: 'Actualizado por',
          sortable: true
        },
        {
          key: 'deleted',
          label: 'En baja lógica',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones',
          sortable: false
        }
      ]
    }
  }
}
</script>
